




























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Address, Controller } from '@/store/models';
import controllers from '@/store/modules/controllers';

@Component
export default class CAddress extends Vue {
  @Prop() public address!: Address;
  @Prop() public editCallback!: (id: number) => void;
  private gglAddrStr: string = '';

  private updated() {
    this.gglAddrStr = encodeURI(`https://maps.google.com/maps?q=${this.address.city},${this.address.street},${this.address.house}&z=15&ie=UTF8&output=embed`);
  }

  get controllers(): Controller[] {
    return controllers.getControllers;
  }

  private controllersNumber(): number {
    let num = 0;
    if (controllers.getControllers) {
      controllers.getControllers.forEach((ctrl) => {
        if (ctrl.addressId === this.address.id) {
          num++;
        }
      });
    }
    return num;
  }
}
